import { Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import DocumentForm from "./DocumentForm";

function Privacy() {

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Privacy Document" }]} />
        <DocumentForm searchKey="PRIVACY_POLICY" title="Privacy Policy" />
      </Container>
    </div>
  );
}

export default Privacy;
